// src/components/CharacterSelection.js
import React, { useState } from 'react';

const CharacterSelection = ({ onSelect }) => {
  const [playerName, setPlayerName] = useState('');

  const handleSubmit = (character) => {
    if (playerName.trim() === '') {
      alert('Por favor, ingresa tu nombre.');
      return;
    }
    onSelect(character, playerName);
  };

  return (
    <div className="character-selection">
      <h2>Elige tu personaje</h2>
      <div>
        <label htmlFor="playerName">Tu nombre: </label>
        <input
          type="text"
          id="playerName"
          value={playerName}
          onChange={(e) => setPlayerName(e.target.value)}
          placeholder="Ingresa tu nombre"
        />
      </div>
      <div className="characters">
        <button onClick={() => handleSubmit('Caballero')}>
          <img src={require('../assets/caballero.png')} alt="Caballero" />
          <p>Caballero</p>
        </button>
        <button onClick={() => handleSubmit('Arquero')}>
          <img src={require('../assets/arquero.png')} alt="Arquero" />
          <p>Arquero</p>
        </button>
        <button onClick={() => handleSubmit('Mago')}>
          <img src={require('../assets/mago.png')} alt="Mago" />
          <p>Mago</p>
        </button>
      </div>
    </div>
  );
};

export default CharacterSelection;